"use client";

import { PortfolioPitch } from "@/components/PortfolioPitch";

/**
 * The video-intro thumbnail (a real face under a scrim with a cobalt play
 * button). Clicking it opens the shared portfolio pitch modal (PortfolioPitch),
 * which sells attaching a changemaker page to job applications.
 */
export function VideoThumb({
  label = "90-sec introduction",
  duration = "1:30",
  className = "",
  surface = "unknown",
}: {
  label?: string;
  duration?: string;
  className?: string;
  /** Where this thumb lives — attached to analytics events. */
  surface?: string;
}) {
  return (
    <PortfolioPitch
      surface={surface}
      className={`group relative block w-full overflow-hidden rounded-md ${className}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/images/video-intro-thumb.jpg"
        alt=""
        loading="lazy"
        className="aspect-video w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
      />
      <span aria-hidden className="absolute inset-0 bg-ink/20" />
      <span aria-hidden className="absolute inset-0 flex items-center justify-center">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/95 shadow-[0_2px_10px_rgba(19,26,38,0.35)] transition-transform group-hover:scale-110">
          <span className="ml-0.5 inline-block border-y-[6px] border-l-[10px] border-y-transparent border-l-brand-600" />
        </span>
      </span>
      <span
        aria-hidden
        className="telex absolute bottom-2 left-2 rounded bg-ink/75 px-1.5 py-0.5 text-[8px] text-white"
      >
        {label}
      </span>
      <span
        aria-hidden
        className="telex absolute bottom-2 right-2 rounded bg-ink/75 px-1.5 py-0.5 text-[8px] text-white"
      >
        {duration}
      </span>
    </PortfolioPitch>
  );
}
